import type { ErrorComponentProps } from '@tanstack/react-router';
import { useEffect } from 'react';
import { DefaultCatchBoundary } from '@/components/DefaultCatchBoundary';
import { onReady } from '@/lib/pwa';

// Mount inside the experience's Suspense boundary. The native loader must
// cover streaming + hydration, including the hero's layout effects. Two
// animation frames give the browser a paint opportunity before revealing the
// WebView; a single frame can still run before that first paint.
export function CbccPwaReady(): null {
	useEffect(() => {
		let frame = requestAnimationFrame(() => {
			frame = requestAnimationFrame(onReady);
		});
		return () => cancelAnimationFrame(frame);
	}, []);

	return null;
}

// A failed experience chunk must reveal the retry screen as well; otherwise
// its Suspense sibling never mounts and the native loader would cover the error.
export function CbccPwaError(props: ErrorComponentProps) {
	return (
		<>
			<DefaultCatchBoundary {...props} />
			<CbccPwaReady />
		</>
	);
}
